export default "__VITE_PUBLIC_ASSET__b10ed651__"